export const BREAKPOINTS = Object.freeze({
  smallPalm: 480,
  mobile: 600,
  handheld: 800,
  portable: 1024
} as const)
